import {PIXI} from '@colonist/pixi'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {SectionBgAdaptiveView} from '../../ui_canvas_engine/SectionBgViewAdaptive'
import {UIGameManager} from '../UIGameManager'
import {UIGamePopupConfirmationButtons} from './UIGamePopupConfirmationButtons'
import {UIGamePopupSelectDiceContainer} from './UIGamePopupSelectDiceContainer'
import {DicePair, SelectDiceFormat} from '@colonist/game-base-types'

export class UIGamePopupSelectDice extends SectionBgAdaptiveView {
    private readonly uiGameManager: UIGameManager
    private readonly selectDiceFormat: SelectDiceFormat
    private readonly popupImageAndDescription: PIXI.Container
    private bottomDiceContainer: UIGamePopupSelectDiceContainer
    private topDiceContainer: UIGamePopupSelectDiceContainer
    private confirmationButtons: UIGamePopupConfirmationButtons

    private onCancelButton: () => void

    // TODO: Remove me while refactoring UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
    private readonly isUserOnMobileApp: boolean

    constructor(uiGameManager: UIGameManager, popupImageAndDescription: PIXI.Container, selectDiceFormat: SelectDiceFormat) {
        super()
        this.uiGameManager = uiGameManager
        this.selectDiceFormat = selectDiceFormat
        this.popupImageAndDescription = popupImageAndDescription

        const canvas = this.uiGameManager.canvasController
        canvas.app.stage.addChild(this)

        this.popupImageAndDescription = popupImageAndDescription
        this.addChild(this.popupImageAndDescription)

        this.isUserOnMobileApp = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        this.createSelectDiceContainer()
        this.createConfirmationButtons()
        this.addEventToCloseUIOnTapOffView()
        this.drawTextureBgAroundContent()
        this.setContainerY()
    }

    private createSelectDiceContainer() {
        const selectedDiceAction = () => {
            this.clickedDiceAction()
        }
        const canvas = this.uiGameManager.canvasController
        const w = canvas.popupWidth

        const diceHeight = canvas.itemSize * (this.isUserOnMobileApp ? 1 : 0.75)
        const topDiceY = this.popupImageAndDescription.y + this.popupImageAndDescription.height
        const redDice = true
        this.topDiceContainer = new UIGamePopupSelectDiceContainer(0, topDiceY, w, diceHeight, this, selectedDiceAction, redDice)
        this.topDiceContainer.drawRoundedBg()

        const bottomDiceY = this.topDiceContainer.y + this.topDiceContainer.height
        this.bottomDiceContainer = new UIGamePopupSelectDiceContainer(0, bottomDiceY, w, diceHeight, this, selectedDiceAction, !redDice)
    }

    private createConfirmationButtons() {
        const clickedCheckAction = () => {
            this.clickedCheckAction()
        }
        this.onCancelButton = () => undefined
        const canvas = this.uiGameManager.canvasController
        const w = canvas.popupWidth
        const buttonH = canvas.itemSize * (this.isUserOnMobileApp ? 1 : 0.55)
        const buttonY = this.absoluteHeight - buttonH
        const showCancelButton = this.selectDiceFormat.cancelButtonActive && !this.isUserOnMobileApp
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, buttonY, w, buttonH, clickedCheckAction, this.onCancelButton, this, showCancelButton)
    }

    private addEventToCloseUIOnTapOffView() {
        if(!this.isUserOnMobileApp) return
        if(!this.selectDiceFormat.cancelButtonActive) return
        this.uiGameManager.mapController.mapView.on('pointerdown', this.onCancelButton)
    }

    private setContainerY() {
        const canvas = this.uiGameManager.canvasController
        this.y = canvas.appH - canvas.bottomViewHeight - this.absoluteHeight
    }

    private clickedDiceAction() {
        if(!this.areBothDiceSelected()) return
        this.confirmationButtons.checkButton.activateOpacity()
    }

    private clickedCheckAction() {
        if(!this.areBothDiceSelected()) return
        const dice1 = this.topDiceContainer.getSelectedDiceNumber()
        const dice2 = this.bottomDiceContainer.getSelectedDiceNumber()
        if(dice1 == undefined) return
        if(dice2 == undefined) return

        const dicePair: DicePair = {
            dice1: dice1,
            dice2: dice2,
        }
        this.uiGameManager.socketGameSend.confirmDiceSelection(dicePair)
        this.closeUI()
    }

    private areBothDiceSelected(): boolean {
        if(!this.topDiceContainer.isDiceSelected()) return false
        if(!this.bottomDiceContainer.isDiceSelected()) return false

        return true
    }

    private closeUI() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
        this.destroy()
    }

    destroy() {
        this.uiGameManager.mapController.mapView.off('pointerdown', this.onCancelButton)
        super.destroy()
    }
}
